var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-group"},[_c('label',[(_vm.labelIcon)?_c('BaseIcon',{attrs:{"type":_vm.labelIcon}}):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.label))]),_vm._t("link")],2),_c('div',{staticClass:"form-group__content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }